import {pageInfo, initPage,initUpdate,exportData} from './../api';
import {selectBusinessType} from '../../../../api'
const intDatapack = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    initPageObj: null,
    initUpdateObj: null,
    businessTypeObj:null,
    exportObj: null,
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    BUSINESS_TYPE(state,data) {
      state.businessTypeObj = data.obj || {};
    },
    //导出
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //业务类型
    async selectBusinessType({commit}, obj){
      let resp = await selectBusinessType(obj);
      commit('BUSINESS_TYPE', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
  }
}
export default intDatapack



// WEBPACK FOOTER //
// ./src/page/log/intDatapack/store/intDatapack.store.js